import React from "react";
import styled from "styled-components";
// Components
import BlogBox from "components/BlogBox";
import FullButton from "components/Button/FullButton";
import TestimonialSlider from "components/TestimonialSlider";
import ClientSlider from "components/ClientSlider";

export default function Blog() {
  return (
    
    <Wrapper id="blog">
   
      <div className="whiteBg" style={{ padding: "60px 0" }}>
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">How to scale with D2Trust?</h1>
            {/* <p className="font13">
              Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut
              <br />
              labore et dolore magna aliquyam erat, sed diam voluptua.
            </p> */}
          </HeaderInfo>
          <div className="row textCenter">
            
            <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3">
              <BlogBox
                title="Setup your offering"
                text="Setup your product/serivce that you'd like to sell along with training materials for your retail sellers."
                icon="product"
        
              />
            </div>
            <img
              src="images/img_directionline.svg"
              className="col-xs-1 col-sm-1 col-md-1 col-lg-1"
              alt="DirectionLine"
            />
            <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3">
            <BlogBox
                title="Start engines"
                text="Our fleet of retail sellers will initiate targetted referrals post training."
                icon="engine"
                
              />
            </div>
            <img
              src="images/img_directionline.svg"
              className="col-xs-1 col-sm-1 col-md-1 col-lg-1"
              alt="DirectionLine"
            />
            <div className="col-xs-12 col-sm-3 col-md-3 col-lg-3">
            <BlogBox
                title="New customers"
                text="Track the lifecycle in realtime as new customers sign-up to your offering!"
                icon="customer" 
              />
            </div>
          </div>
          {/* <div className="row textCenter">
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <BlogBox
                title="New Office!"
                text="Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor."
                tag="company"
                author="Luke Skywalker, 2 days ago"
                action={() => alert("clicked")}
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <BlogBox
                title="New Office!"
                text="Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor."
                tag="company"
                author="Luke Skywalker, 2 days ago"
                action={() => alert("clicked")}
              />
            </div>
            <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
              <BlogBox
                title="New Office!"
                text="Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor."
                tag="company"
                author="Luke Skywalker, 2 days ago"
                action={() => alert("clicked")}
              />
            </div>
          </div> */}
          {/* <div className="row flexCenter">
            <div style={{ margin: "50px 0", width: "200px" }}>
              <FullButton title="Load More" action={() => alert("clicked")} />
            </div>
          </div> */}
        </div>
       
      </div>
      <div className="lightBg" style={{ padding: "50px 0" }}>
        <div className="container">
          <ClientSlider />
        </div>
      </div>
      {/* <div className="lightBg" style={{padding: '50px 0'}}>
        <div className="container">
          <HeaderInfo> 
            <h1 className="font40 extraBold">What They Say?</h1>
            <p className="font13">
              Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut
              <br />
              labore et dolore magna aliquyam erat, sed diam voluptua.
            </p>
          </HeaderInfo>
          <TestimonialSlider />
        </div>
      </div> */}
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
  padding-top: 20px;
`;
const HeaderInfo = styled.div`
  margin-bottom: 30px;
  @media (max-width: 860px) {
    text-align: center;
  }
`;